const _excluded = ["onFocus", "onBlur", "label", "error"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.array.iterator.js";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import { BigInputComponent } from "../../big-input";
import React from 'react';
import { InputTextarea } from "../input-textarea.component";
export const InputTextareaBig = props => {
  const {
      onFocus,
      onBlur,
      label,
      error
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const [focused, setFocused] = React.useState(false);
  const ref = React.useRef(null);
  return /*#__PURE__*/React.createElement(BigInputComponent, {
    error: error,
    focused: focused,
    label: label
  }, /*#__PURE__*/React.createElement(InputTextarea, _extends({
    ref: ref,
    onFocus: () => {
      onFocus && onFocus();
      setFocused(true);
    },
    onBlur: () => {
      onBlur && onBlur();
      setFocused(false);
    },
    error: error
  }, rest)));
};